<template>
  <div class="wtv-hero-cell wtv-layout wtv-stats">
    <div
      class="wtv-stats-item"
      v-for="stats in statsList"
      :key="stats.name"
    >{{ stats.name }}: {{ stats.amount }}</div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'Stats',
  setup() {
    const $store = useStore();
    const statsList = computed(() => $store.state.stats);
    return {
      statsList,
    };
  },
});
</script>

<style scoped>
.wtv-stats {
  flex-flow: row wrap;
  justify-content: space-between;
  flex: 2 0 100% !important;
}
.wtv-stats-item {
  padding: 8px;
}
</style>
